import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import { fetchVacancyCalendarDataAsync } from './actions';

import type { TourInfo, VacancyCalendarDate, VacancyCalendarErrors } from 'VacancyCalendar-Types';

export const isFetching = createReducer(false as boolean)
  .handleAction([fetchVacancyCalendarDataAsync.request], () => true)
  .handleAction(
    [fetchVacancyCalendarDataAsync.success, fetchVacancyCalendarDataAsync.failure],
    () => false,
  );

export const calendars = createReducer([] as VacancyCalendarDate[])
  .handleAction(fetchVacancyCalendarDataAsync.success, (_state, action) => {
    return action.payload.calendars;
  })
  .handleAction(fetchVacancyCalendarDataAsync.failure, () => []);

export const tourInfo = createReducer({} as TourInfo)
  .handleAction(fetchVacancyCalendarDataAsync.success, (_state, action) => {
    return action.payload.tourInfo;
  })
  .handleAction(fetchVacancyCalendarDataAsync.failure, () => ({} as TourInfo));

export const errors = createReducer({} as VacancyCalendarErrors)
  .handleAction(fetchVacancyCalendarDataAsync.failure, (_state, action) => action.payload)
  .handleAction(fetchVacancyCalendarDataAsync.request, () => ({} as VacancyCalendarErrors));

const vacancyCalendarReducer = combineReducers({
  isFetching,
  calendars,
  tourInfo,
  errors,
});

export default vacancyCalendarReducer;
export type VacancyCalendarState = ReturnType<typeof vacancyCalendarReducer>;
